$(document).ready(function() {
  if ($('.home-hero').length) {
    var index = 0;
    if (getCookie('home_image')) {
      indexPrev = getCookie('home_image');
      console.log(indexPrev)
      if (indexPrev < $('.home-hero .images .item').length-1) {
        index = ++indexPrev;
      }
    } 
    $('.home-hero .images .item').eq(index).show(0);
    setCookie('home_image', index, 30);
  }

  if ($('.google-reviews-section').length) {
    var j = setInterval(function() {
      if ($('.google-reviews-section').find('.swiper-slide').length) {
        clearInterval(j);
        var items = $('.google-reviews-section').find('.swiper-wrapper');
        for (var i=0; i<7; i++) {
          var item = items.find(`.swiper-slide[key="${i}"]`);
          if (item.length) {
            $('.google-reviews-section .google-reviews-slider').append(`
              <div class="item">
                ${item.find('.grp-entangle-item-body-stars').html().trim()}
                ${item.find('.grp-entangle-item-body-review').html().trim()}
                <div class="info">
                  ${item.find('.grp-entangle-item-head-image').html().trim()}
                  <div class="author">
                    ${item.find('.grp-entangle-item-head-name').html().trim()} <span class="divider">|</span> ${item.find('.grp-entangle-item-date').html().trim()}
                  </div>
                </div>
              </div>
            `);
          }
        }

        $('.google-reviews-section .verified-reviews').attr('href', $('.grp-entangle-all-review').attr('href'));

        $('.google-reviews-section .google-reviews-slider').slick({
          accessibility: false,
          arrows: false,
          dots: true,
          mobileFirst: true,
          autoplay: true,
          speed: 500,
          responsive: [
            {
              breakpoint: 999,
              settings: {
                centerMode: true,
                variableWidth: true,
                dots: false,
              }
            }
          ]
        }).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
          if (currentSlide !== nextSlide) {
              document.querySelectorAll('.slick-center + .slick-cloned').forEach((next) => {
                  // timeout required or Slick will overwrite the classes
                  setTimeout(() => next.classList.add('slick-current', 'slick-center'));
              });
          }
        });;
      }
    }, 300);
  }

  $('.announcement-bar li.has-submenu > a').click(function(e) {
    e.preventDefault();
    var li = $(this).closest('li');
    li.find('> ul').fadeToggle(100);
    li.siblings().find('ul').fadeOut(100);
    li.siblings().removeClass('active');
    li.toggleClass('active');
  });

  const firstNonMobileLi = document.querySelector('.mega-menu .main-menu li:not(.mobile)');

  if (firstNonMobileLi) {
    firstNonMobileLi.classList.add('desktop-active');
  }

  $('header .mega-menu .main-menu > li > a').click(function(e) {
    var $item = $(this).closest('li');
    var $subitem = $item.find('.subitem');
    var $itemSiblings = $item.siblings();
    var $subitemSiblings = $itemSiblings.find('.subitem');

    if ($subitem.length) {
      e.preventDefault();

      if ($(window).width() < 1100) {
        $itemSiblings.removeClass('mobile-active');
        $subitemSiblings.removeClass('mobile-active');

        $item.toggleClass('mobile-active');
        $subitem.toggleClass('mobile-active');
      } else {
        $itemSiblings.removeClass('desktop-active');
        $subitemSiblings.removeClass('desktop-active');

        $item.addClass('desktop-active');
        $subitem.addClass('desktop-active');
      }
    }
  });

  $('a[href="#mega-menu"], .menu-toggle').click(function(e) {
    e.preventDefault();
    $('header .mega-menu').fadeToggle(200);
    $(this).toggleClass('active');
  });

  $('.tabs .tab-items h3').click(function() {
    var tabs = $(this).closest('.tabs');
    var $item = $(this).closest('.item');
    $item.siblings('.item').removeClass('active');
    $item.siblings('.item').each(function() {
      var $sib = $(this);
      $sib.find('.text').prop('hidden', true);
      $sib.find('[aria-expanded]').attr('aria-expanded', 'false');
    });
    $item.toggleClass('active');
    var isActive = $item.hasClass('active');
    $item.find('.text').prop('hidden', !isActive);
    $item.find('[aria-expanded]').attr('aria-expanded', isActive ? 'true' : 'false');
    tabs.find('li').removeClass('active');
    tabs.find('li').eq($item.index()).addClass('active');
  });

  $('.tabs .tabs-nav h3').click(function() {
    var tabs = $(this).closest('.tabs');
    tabs.find('li').removeClass('active');
    $(this).closest('li').toggleClass('active');
    tabs.find('.item').removeClass('active');
    tabs.find('.item').eq($(this).closest('li').index()).addClass('active');
  });

  $('.accordion-section .show-more').click(function(e) {
    e.preventDefault();
    $(this).closest('.accordion-section').find('.accordion .item').addClass('visible');
    $(this).closest('.button').remove();
  });

  $('a[href="#login-popup"').click(function(e) {
    e.preventDefault();
    $('#login-popup').fadeIn(200);
  });

  $('a[href="#get-started"').click(function(e) {
    e.preventDefault();
    $('#popup-mask-fitting').fadeIn(200);
  });

  $('.popup .close').click(function(e) {
    e.preventDefault();
    $('.popup').fadeOut(200);
  });

  $('a[href="#recover-password"]').click(function(e) {
    $('#customer_login').hide(0);
    $('#login-form-text').hide(0);
    $('#recover_customer_password').show(0);
  });

  $('#open-login-drawer').click(function(e) {
    const isOpen = $('#drawer-login').toggleClass('open').hasClass('open');
    $('#drawer-login')[0].inert = !isOpen;
    $('.header-icon.header-account').toggleClass('active');
    if (isOpen) $('#drawer-login').find('a, button, input').first().focus();
  });

  $('#open-cart-drawer').click(function(e) {
    const isOpen = $('#mini-cart').toggleClass('open').hasClass('open');
    $('#mini-cart')[0].inert = !isOpen;
    $('.header-icon.header-cart').toggleClass('active');
    if (isOpen) $('#mini-cart').find('a, button, input').first().focus();
  });

  $('.header-drawer .close').click(function(e) {
    $('#drawer-login, #mini-cart').removeClass('open').each(function() {
      this.inert = true;
    });
    $('.header-icon').removeClass('active');
    $('#open-login-drawer, #open-cart-drawer').filter('.active').focus();
  });

  Marquee3k.init();

  $('.pdp-main .slider-for').slick({
    accessibility: false,
    centerMode: true,
    variableWidth: true,
    arrows: false,
    mobileFirst: true,
    asNavFor: '.pdp-main:not(.pdp-main-supplies) .slider-nav',
    initialSlide: 1,
    responsive: [
        {
            breakpoint: 999,
            settings: {
                fade: true,
                centerMode: false,
                initialSlide: 0,
                variableWidth: false
            }
        }
    ]
});


  $('.pdp-main .slider-nav .item').click(function() {
    var images = $(this).closest('.images');
    images.find('.slider-for').slick('slickGoTo', $(this).data('slick-index'));
    $(this).addClass('selected');
    $(this).siblings().removeClass('selected');
    images.find('.slider-nav').slick('slickNext');
  });

  $('.pdp-main .slider-nav').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    var images = $(this).closest('.images');
    images.find('.slider-for').slick('slickGoTo',currentSlide);
  });

  $('.pdp-main .slider-for').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    document.querySelectorAll('.js-youtube').forEach(video => {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
        '*'
      );
    });

    document.querySelectorAll('video').forEach(video => video.pause());
  });

  $('.pdp-main:not(.pdp-main-supplies) .slider-nav').slick({
    accessibility: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    //initialSlide: 1,
    asNavFor: '.pdp-main .slider-for', // This line synchronizes slider-nav with slider-for
  });


  $('.pdp-main-supplies .slider-nav').slick({
    accessibility: false,
    slidesToShow: 7,
    slidesToScroll: 1,
    variableWidth: true
  });

  $('.pdp-main .all-features:not(.hide)').click(function(e) {
    e.preventDefault();
    var section = $(this).closest('.pdp-main');
    section.find('.product-description-desktop, .product-description-mobile').hide(0);
    section.find('.product-description-full').show(0);
  });

  $('.pdp-main .all-features.hide').click(function(e) {
    e.preventDefault();
    var section = $(this).closest('.pdp-main');
    if ($(window).width() < 1100) {
            // Show desktop description
            section.find('.product-description-desktop').hide(0);
            section.find('.product-description-mobile').show(0);
        } else {
            // Show mobile description
            section.find('.product-description-desktop').show(0);
            section.find('.product-description-mobile').hide(0);
        }
    section.find('.product-description-full').hide(0);
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".pdp-info").offset().top - 100
    }, 0);
  });

  $('.pdp-main .add-to-cart .product-form__single-selector').on('change', function() {
    var selected;
    var section = $(this).closest('.pdp-main');
    if ($('.pdp-main .add-to-cart .product-form__single-selector').length > 1) {
      var option1 = $(this).find('option:selected').text();
      $('.pdp-main .add-to-cart .product-form__single-selector').not($(this)).find('option').each(function() {
        var option = $(this).text();
        var newId = $(`#variants-data .variant[data-option-1="${option1}"][data-option-2="${option}"]`).data('id');
        $(this).attr('data-id',newId);
      });
      selected = $('.pdp-main .add-to-cart .product-form__single-selector').eq(1).find('option:selected');
    } else {
      selected = $(this).find('option:selected');
    }
    section.find('.add-to-cart input[name="id"]').val(selected.attr('data-id'));
    section.find('.product-price .real-price').text(selected.attr('data-price'));
    if (selected.attr('data-price-compare')) {
      section.find('.product-price .price--compare').text(selected.attr('data-price-compare'));
      section.find('.product-price .price--compare').show(0);
    } else {
      section.find('.product-price .price--compare').hide(0);
    }

    document.querySelector('.product-sku span').innerText = 'SKU '+ selected.attr('data-sku');

    var image = $(`.slider-nav .item[data-variants="${selected.attr('data-id')}"]:not(.slick-cloned)`);
    if (image) {
      image.click();
    }
  });

  $('.collection-filters:not(.collection-filters-bundle) .filter-group:not(.filter-group-categories) input[type="checkbox"]').on('change', function(e) {
    $('.filter-form').submit();
  });

  $('.filter-form').on('submit', function(e) {
    e.preventDefault();
    var params = new URLSearchParams();
    new FormData(this).forEach(function(value, key) {
      if (value !== '') {
        params.append(key, value);
      }
    });
    var hash = window.location.hash || '#collection-hero';
    window.location.href = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + hash;
  });

  $('.filter-group .filter-name').click(function() {
    $(this).closest('.filter-group').toggleClass('active');
    if ($(window).width() >= 1000) {
      $(this).closest('.filter-group').siblings().removeClass('active');
    }
  });

  $('.filters-title').click(function() {
    $('.filter-wrap').not($(this).siblings('.filter-wrap')).hide(0);
    $(this).siblings('.filter-wrap').toggle(0);
  });

  $('.filter-wrap .close').click(function() {
    $(this).closest('.filter-wrap').hide(0);
  });

  $('.benefits-section .slider').slick({
    accessibility: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          fade: true
        }
      }
    ]
  });

  $('.pdp-links .slider').slick({
    accessibility: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
    arrows: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 999,
        settings: "unslick"
      }
    ]
  });

  $('.quantity-selector .quantity-plus').click(function(e) {
    e.preventDefault();
    var val = $('#quantity-input').val();
    $('#quantity-input').val(++val);
  });

  $('.quantity-selector .quantity-minus').click(function(e) {
    e.preventDefault();
    var val = $('#quantity-input').val();
    if (val > 1) {
      $('#quantity-input').val(--val);
    }
  });

  $('.category-gallery .slider').slick({
    accessibility: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
    arrows: false,
    dots: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 999,
        settings: "unslick"
      }
    ]
  });

  $('.icon-row-section .icons').slick({
    accessibility: false,
    centerMode: true,
    variableWidth: true,
    arrows: false,
    dots: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 999,
        settings: "unslick"
      }
    ]
  });

  $('.featured-category-section .slider').slick({
    accessibility: false,
    variableWidth: true,
    arrows: false,
    mobileFirst: true,
    infinite: false,
    responsive: [
    ]
  });

  $('.steps-section .icons').slick({
    accessibility: false,
    arrows: false,
    dots: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 999,
        settings: "unslick"
      }
    ]
  });

  $('.payment-options-banner-section .items').slick({
    accessibility: false,
    arrows: false,
    dots: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 999,
        settings: "unslick"
      }
    ]
  });

  $('.slider-section .slider').slick({
    accessibility: false,
    arrows: false,
    dots: true,
    mobileFirst: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          centerMode: true,
          variableWidth: true
        }
      }
    ]
  }).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
    if (currentSlide !== nextSlide) {
        document.querySelectorAll('.slick-center + .slick-cloned').forEach((next) => {
            // timeout required or Slick will overwrite the classes
            setTimeout(() => next.classList.add('slick-current', 'slick-center'));
        });
    }
  });

  $('.compare-options .slider').slick({
    accessibility: false,
    arrows: false,
    dots: true,
    mobileFirst: true,
    centerMode: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 999,
        settings: "unslick"
      }
    ]
  }).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
    if (currentSlide !== nextSlide) {
        document.querySelectorAll('.slick-center + .slick-cloned').forEach((next) => {
            // timeout required or Slick will overwrite the classes
            setTimeout(() => next.classList.add('slick-current', 'slick-center'));
        });
    }
  });

  $('.product-row-section .load-more').click(function(e) {
    e.preventDefault();
    $(this).closest('.product-row-section').find('.product-card').show(0);
    $(this).closest('.button').remove();
  });

  $('.video-wrap .play-btn').click(function() {
    var video = $(this).closest('.video-wrap');
    video.find('video')[0].play();
    $(this).closest('.video-overlay').remove();
  });

  $('.philosophy-tabs-nav .item').click(function() {
    var index = $(this).index();
    var tabs = $(this).closest('.our-philosophy');
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    tabs.find('.philosophy-tabs-content .image-text-section').removeClass('active');
    tabs.find('.philosophy-tabs-content .image-text-section').eq(index).addClass('active');
  });

  $('.philosophy-tabs-nav .arrow').click(function() {
    var tabs = $(this).closest('.our-philosophy');
    var index = tabs.find('.philosophy-tabs-nav .item.active').index();
    var nextIndex = $(this).hasClass('next-arrow') ?
      (index < 2) ? ++index : index :
      (index > 0) ? --index : index;
    tabs.find('.philosophy-tabs-nav .item').removeClass('active');
    tabs.find('.philosophy-tabs-nav .item').eq(nextIndex).addClass('active');
    tabs.find('.philosophy-tabs-content .image-text-section').removeClass('active');
    tabs.find('.philosophy-tabs-content .image-text-section').eq(nextIndex).addClass('active');
  });

  $(document).mouseup( function(e){
    var div = $( ".announcement-bar li.has-submenu" );
    if ( !div.is(e.target)
        && div.has(e.target).length === 0 ) {
        div.find('ul').fadeOut(100);
        div.removeClass('active');
    }

    var popup =  $( ".popup .popup-content");
		if ( !popup.is(e.target)
		    && popup.has(e.target).length === 0 ) {
      $('.popup').fadeOut(200);
		}

    var drawer =  $( ".header-drawer");
		if ( !drawer.is(e.target)
		    && drawer.has(e.target).length === 0 ) {
      $('.header-drawer').removeClass('open');
      $('.header-icon.header-account').removeClass('active');
		}

    var filter =  $( ".filter-group");
		if ( !filter.is(e.target)
		    && filter.has(e.target).length === 0 ) {
      filter.removeClass('active');
		}

    var sort =  $( ".sort-form");
		if ( !sort.is(e.target)
		    && sort.has(e.target).length === 0 ) {
        sort.find('.filter-wrap').hide(0);
		}

    var bundleDropdown =  $(".product-card-bundle .product-bottom");
		if ( !bundleDropdown.is(e.target)
		    && bundleDropdown.has(e.target).length === 0 ) {
        bundleDropdown.find('.select-variant-wrap').hide(0);
		}

    var menuDropdown =  $("header");
		if ( !menuDropdown.is(e.target)
		    && menuDropdown.has(e.target).length === 0 ) {
        $("header .mega-menu").fadeOut(200);
        $("header a").removeClass('active');
		}

    var paymentOptions =  $(".payment-options-wrap");
		if ( !paymentOptions.is(e.target)
		    && paymentOptions.has(e.target).length === 0 ) {
        $(".payment-options-popup").hide(0);
		}
	});

  var w = $(window).width();
  $(window).on('resize', function() {
    if (w >= 1000 && $(window).width() < 1000) {
      $('.pdp-links .slider').slick('unslick');
      $('.category-gallery .slider').slick('unslick');
      $('.icon-row-section .icons').slick('unslick');
      $('.steps-section .icons').slick('unslick');
      $('.compare-options .slider').slick('unslick');
      $('.payment-options-banner-section .items').slick('unslick');

      $('.pdp-links .slider').slick({
        accessibility: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        arrows: false,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 999,
            settings: "unslick"
          }
        ]
      });

      $('.category-gallery .slider').slick({
        accessibility: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        arrows: false,
        dots: true,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 999,
            settings: "unslick"
          }
        ]
      });

      $('.icon-row-section .icons').slick({
        accessibility: false,
        centerMode: true,
        variableWidth: true,
        arrows: false,
        dots: true,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 999,
            settings: "unslick"
          }
        ]
      });

      $('.steps-section .icons').slick({
        accessibility: false,
        arrows: false,
        dots: true,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 999,
            settings: "unslick"
          }
        ]
      });

      $('.compare-options .slider').slick({
        accessibility: false,
        arrows: false,
        dots: true,
        mobileFirst: true,
        centerMode: true,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 999,
            settings: "unslick"
          }
        ]
      }).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        if (currentSlide !== nextSlide) {
            document.querySelectorAll('.slick-center + .slick-cloned').forEach((next) => {
                // timeout required or Slick will overwrite the classes
                setTimeout(() => next.classList.add('slick-current', 'slick-center'));
            });
        }
      });

      $('.payment-options-banner-section .items').slick({
        accessibility: false,
        arrows: false,
        dots: true,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 999,
            settings: "unslick"
          }
        ]
      });
    }
    w = $(window).width();
  });

  if ($('.shop-all-section').length) {
    var initCollection = $('.shop-all-section .product-grid').html();
    filterCollection();

    $('.shop-all-section .category-filter input, .shop-all-section .brand-filter input').on('change', function () {
      filterCollection();
    });

    $('.shop-all-section .price-filter input[type="submit"]').on('click', function (e) {
      e.preventDefault();
      filterCollection();
    });

    $('.shop-all-section a[href="#remove-all-filters"]').click(function (e) {
      e.preventDefault();
      $('.shop-all-section .filter-item input[type="checkbox"]').prop('checked', false);
      var priceMinInput = $('.shop-all-section .price-filter input#Filter-price-min');
      var priceMaxInput = $('.shop-all-section .price-filter input#Filter-price-max');
      priceMinInput.val(0);
      priceMaxInput.val(priceMaxInput.data('init-val'));
      filterCollection();
    });

    $('.shop-all-section #load-more').click(function(e) {
      e.preventDefault();
      var lastShown = $('.shop-all-section .product-card.mobile-shown').last();
      lastShown.next().addClass('mobile-shown').next().addClass('mobile-shown');
      if ($('.shop-all-section .product-card.mobile-shown').length == $('.shop-all-section .product-card').length) {
        $(this).removeClass('visible');
      }
    });

    function drawPagination(currentPage) {
      var length = $('.shop-all-section .product-grid .product-card').length;
      var pageNum = length / 3;
      if (length % 3 == 0) {
        pageNum--;
      }
      if (pageNum > 1) {
        $('.shop-all-section .product-card').removeClass('desktop-shown');
        for (var i = 3; i > 0; i--) {
          $('.shop-all-section .product-card').eq(currentPage * 3 - i).addClass('desktop-shown');
        }
        var html = `<li class="prev">
          <a href="#">
            <i class="icofont-simple-left"></i>
            Previous
          </a>
        </li>`;
        for (var i = 0; i <= pageNum; i++) {
          html += `<li data-page="${i + 1}">
            <a href="#">
              ${i + 1}
            </a>
          </li>`;
        }
        html += `<li class="next">
          <a href="#">
            Next
            <i class="icofont-simple-right"></i>
          </a>
        </li>`;
        $('.shop-all-section .pagination .wrapper').html('<ul>' + html + '</ul>');
        $(`.shop-all-section .pagination li[data-page="${currentPage}"]`).addClass('active');
      } else {
        $('.shop-all-section .product-card').show(0);
        $('.shop-all-section .pagination .wrapper').html('');
      }

      $('.shop-all-section li:not(.next,.prev) a').click(function(e) {
        e.preventDefault();
        var page = $(this).closest('li').data('page');
        drawPagination(page);
        scrollToShopAllSection();
      });

      $('.shop-all-section .prev a').click(function(e) {
        e.preventDefault();
        var page = $('.shop-all-section li.active').data('page');
        if (page > 1) {
          drawPagination(--page);
          scrollToShopAllSection();
        }
      });

      $('.shop-all-section .next a').click(function(e) {
        e.preventDefault();
        var page = $('.shop-all-section li.active').data('page');
        if (page <= pageNum) {
          drawPagination(++page);
          scrollToShopAllSection();
        }
      });
    }

    function filterCollection() {
      var selectedTags = [], selectedBrands = [];
      var priceFilterActive = false;
      $('.shop-all-section').find('.active-filters .active-filter').remove();
      $('.shop-all-section').find('.filter-group').removeClass('active');
      $('.shop-all-section').find('.filter-wrap').hide(0);
      $('.shop-all-section').find('.category-filter input').each(function () {
        if ($(this).is(':checked')) {
          selectedTags.push($(this).val());
          $('.shop-all-section').find('.active-filters').append(`<a class="active-filter active-filters__remove-filter category" data-tag="${$(this).val()}" href="#"><i class="icofont-close-circled"></i> ${$(this).val()}</a>`);
        }
      });
      $('.shop-all-section').find('.brand-filter input').each(function () {
        if ($(this).is(':checked')) {
          selectedBrands.push($(this).val());
          $('.shop-all-section').find('.active-filters').append(`<a class="active-filter active-filters__remove-filter brand" data-tag="${$(this).val()}" href="#"><i class="icofont-close-circled"></i> ${$(this).val()}</a>`);
        }
      });
      var priceMinInput = $('.shop-all-section').find('.price-filter input#Filter-price-min');
      var priceMaxInput = $('.shop-all-section').find('.price-filter input#Filter-price-max');
      if (priceMinInput.val() !== '' && priceMaxInput.val() !== '' && (priceMinInput.val() != +priceMinInput.data('init-val') ||  priceMaxInput.val() != +priceMaxInput.data('init-val'))) {
        priceFilterActive = true;
      }
      if (selectedTags.length || selectedBrands.length || priceFilterActive) {
        var filteredItemsHTML = '';
        var defaultItems = initCollection;
        $(defaultItems).find('.product-card').each(function () {
          if (selectedTags.length) {
            var matchesTags = false;
            var tags = $(this).data('tags');
            for (tag of selectedTags) {
              if (tags.includes(tag)) {
                matchesTags = true;
                break;
              }
            }
            if (!matchesTags) return;
          }
          if (selectedBrands.length) {
            var vendor = $(this).data('vendor');
            if (!selectedBrands.includes(vendor)) return;
          }
          if (priceFilterActive) {
            var minPrice = +priceMinInput.val();
            var maxPrice = +priceMaxInput.val().replace('.', ',');
            var productPrice = +$(this).attr('data-price') / 100;
            if (productPrice < minPrice || productPrice > maxPrice) {
              return;
            }
          }
          filteredItemsHTML += $(this).get(0).outerHTML;
        });
        $('.shop-all-section .product-grid').html('<div class="wrapper">' + filteredItemsHTML + '</div>');
        $('.shop-all-section').find('.active-filters').show(0);
      } else {
        $('.shop-all-section .product-grid').html(initCollection);
        $('.shop-all-section').find('.active-filters').hide(0);
      }
      if (selectedTags.length) {
        $('.shop-all-section').find('.category-filter .filter-name span').text(' (' + selectedTags.length + ')');
      } else {
        $('.shop-all-section').find('.category-filter .filter-name span').text('');
      }
      if (selectedBrands.length) {
        $('.shop-all-section').find('.brand-filter .filter-name span').text(' (' + selectedBrands.length + ')');
      } else {
        $('.shop-all-section').find('.brand-filter .filter-name span').text('');
      }
      $('.shop-all-section').find('.filters-title .filter-num').text('(' + (selectedTags.length + selectedBrands.length) + ')');

      drawPagination(1);
      $('.shop-all-section .product-grid').removeClass('mobile-shown');
      $('.shop-all-section .product-grid').find('.product-card:nth-child(1),.product-card:nth-child(2)').addClass('mobile-shown');
      $('.shop-all-section #load-more').removeClass('visible');
      if ($('.shop-all-section .product-card').length > 2) {
        $('.shop-all-section #load-more').addClass('visible');
      }
      $('.active-filters__remove-filter').click(function (e) {
        e.preventDefault();
        var tag = $(this).attr('data-tag');
        var collection = $(this).closest('.collection');
        var index = $(this).closest('.item').index();
        $('.shop-all-section').find(`input[type="checkbox"][value="${tag}"]`).prop('checked', false);
        filterCollection(collection, index);
        $(this).remove();
      });

      $('.shop-all-section a[href="#login-popup"').click(function(e) {
        e.preventDefault();
        $('#login-popup').fadeIn(200);
      });
    }

    function scrollToShopAllSection() {
      $('html, body').animate({
        scrollTop: $(".shop-all-section .collection-filters").eq(0).offset().top - $('header').outerHeight() - 10
    }, 0);
    }
  }

  $('a[href="#quiz"]').click(function(e) {
    e.preventDefault();
    $('#quiz-popup').fadeIn(200);
  });

  $('#quiz-popup .step input').on('change', function() {
    var step = $(this).closest('.step');
    step.find('.btn').removeClass('disabled');
  });

  $('#quiz-popup .step button.next').click(function(e) {
    e.preventDefault();
    if (!$(this).hasClass('disabled')) {
      var step = $(this).closest('.step');
      var nextStep = step.next('.step');
      if (nextStep.length) {
        step.removeClass('active');
        nextStep.addClass('active');
        $('#quiz-popup .progress-bar .bar span').css('width', 100 / $('#quiz-popup .step').length * +nextStep.data('index') + '%');
        $('#quiz-popup .current-step .current').text(nextStep.data('index'));
      } else {
        var results = 0;
        $('#quiz-popup .step input:checked').each(function() {
          results += +$(this).data('points');
        });
        if (results < 2) {
          $('#low-risk').show(0);
        } else if (results < 4) {
          $('#mid-risk').show(0);
        } else {
          $('#high-risk').show(0);
        }
        $('#quiz-popup .quiz-steps').hide(0);
        $('#quiz-popup .final-screen').show(0);
      }
    }
  });

  $('#quiz-popup .arrow-back').click(function(e) {
    e.preventDefault();
    var step = $('#quiz-popup .step.active');
    if (step.data('index') == 1) {
      $('#quiz-popup .quiz-steps').hide(0);
      $('#quiz-popup .start-screen').show(0);
    } else {
      var prevStep = step.prev('.step');
      step.removeClass('active');
      prevStep.addClass('active');
      $('#quiz-popup .progress-bar .bar span').css('width', 100 / $('#quiz-popup .step').length * +prevStep.data('index') + '%');
      $('#quiz-popup .current-step .current').text(prevStep.data('index'));
    }
  });

  $('#quiz-popup #quiz-start').click(function(e) {
    e.preventDefault();
    $('#quiz-popup .start-screen').hide(0);
    $('#quiz-popup .quiz-steps').show(0);
  });

  if ($('#quiz-popup').length) {
    var quizInterval = setInterval(function() {
      if ($('#quiz-popup input[placeholder="Zip Code"]').length) {
        document.querySelector('#quiz-popup input[placeholder="Zip Code"]').addEventListener("keypress", function (evt) {
            if (evt.which < 48 || evt.which > 57)
            {
                evt.preventDefault();
            }
        });
        clearInterval(quizInterval);
      }
    }, 500);
  }
  if ($('.klaviyo-reviews').length) {
    var reviewsInterval = setInterval(function() {
      if ($('.kl_reviews__summary__average__value').length) {
        var val = +$('.kl_reviews__summary__average__value').text();
        if (val % 1 === 0) {
          $('.kl_reviews__summary__average__value').text(val + '.0');
        }
        clearInterval(reviewsInterval);
      }
    }, 500);
  }


  function setCookie(key, value, expiry) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
  }

  function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
  }

  $('.footer-bottom .footer-menus .menu-column h3').click(function() {
    $(this).closest('.menu-column').toggleClass('open');
  });

  $('.payment-options').click(function(e) {
    e.preventDefault();
    $(this).siblings('.payment-options-popup').toggle(0);
  });

  $('.payment-options-popup .close').click(function(e) {
    e.preventDefault();
    $('.payment-options-popup').toggle(0);
  });
});
